export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";